import { EnvironmentService } from '../../../environment/environment-service';
import { Environments } from '../../../environment/environments';
import { PartnerDomains } from '../../constants';
import {
  EffectiveRoleViewAuthorizationService,
  OriginalRoleViewAuthorizationService,
} from '../authorization/service';
import { Hasher } from '../hasher';
import { DomainSettings, HasDependencies, hashString } from '../types';

export class FeatureFlagsService implements HasDependencies {
  /** Use this for features that are in testing stage and not fully rolled out to clients, and so
   * we deploy them on limited environments or only for panalytSuperAdmins.
   * For features that are meant to be accessible to limited user types, use permissions-store
   * For features that are enabled on specific dashboards, use dashboard-configurations-store
   */

  constructor(
    readonly authorizationService: EffectiveRoleViewAuthorizationService,
    readonly domainSettings: DomainSettings,
    readonly environmentService: EnvironmentService,
    readonly originalRoleViewAuthorizationService: OriginalRoleViewAuthorizationService
  ) {}

  public getDeps = (): (string | undefined)[] => [
    hashString([
      ...this.authorizationService.getDeps(),
      ...this.originalRoleViewAuthorizationService.getDeps(),
      Hasher.hash(this.domainSettings),
      ...this.environmentService.getDeps(),
    ]),
  ];

  public isPermissionsUiEnabled = (): boolean => {
    return (
      this.authorizationService.canManageAllDomains() ||
      (this.domainSettings.canUsePermissionsUi ?? false)
    );
  };

  public isSessionRecordingEnabled = (): boolean => {
    return (
      this.originalRoleViewAuthorizationService.canManageAllDomains() &&
      !this.environmentService.isDemo
    );
  };

  public isCrextaPermissionsView = (): boolean => {
    return this.domainSettings.domainOfPartner === PartnerDomains.CREXTA;
  };

  // This doesn't need to be here, it only uses permissions nothing else
  public isAliasEnabled = (): boolean => {
    return this.authorizationService.canManageAliases();
  };

  public isCustomDashboardsEnabled = (): boolean => {
    // TODO: Fix this permission
    return this.authorizationService.canSeeSuperAdminMenu();
  };

  public isChappiEnabled = (): boolean => {
    return (
      this.authorizationService.canManageAllDomains() &&
      this.environmentService.environment.name !== Environments.PANACLOUD_JAPAN
    );
  };
}
